// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"9e1c2ceb","453":"d8159634","566":"451ac459","701":"b498a7e3","956":"3b6aa2d7"}[chunkId] + ".chunk.js";
};